export default {
  title: '交換統計',
  exchangeTime: '交換時間',
  startDate: '開始時間',
  endDate: '終了時間',
  totalPointsConsumed: '消費ポイント総量',
  totalGiftsExchanged: '累計交換ギフト数',
  unitGifts: '件',
  totalOrders: '交換注文総数',
  unitOrders: '件',
  popularRankTitle: '人気交換ギフトランキング',
  rankNo: '順位',
  giftDetail: 'ギフト詳細',
  exchangeQty: '交換数量',
  popularity: '人気割合',
  trendTitle: '最近7日間の交換状況',
  trendSeries: '交換数量',
  rangeLimitTip: '交換期間は最大1年まで対応、以下のデータは検索条件に応じて変わります',
};
